import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DeleteIcon from "@mui/icons-material/Delete";

import useListActionInfo from "lib/list/useListActionInfo";
import { ButtonSize } from "lib/ui/button/ButtonTypes";
import IconButton from "lib/ui/button/IconButton";

export type TableActionbarProps = {
	onMoveUp: (keys: Array<string>) => void;
	onMoveDown: (keys: Array<string>) => void;
	onDelete: (keys: Array<string>) => void;
};

export default function TableActionbar(
	props: Readonly<TableActionbarProps>
): JSX.Element {
	const { t } = useTranslation();

	const listInfo = useListActionInfo();

	const onMoveUp = useCallback(
		() => props.onMoveUp(listInfo.selected),
		[listInfo.selected, props.onMoveUp]
	);

	const onMoveDown = useCallback(
		() => props.onMoveDown(listInfo.selected),
		[listInfo.selected, props.onMoveDown]
	);

	const onDelete = useCallback(
		() => props.onDelete(listInfo.selected),
		[listInfo.selected, props.onDelete]
	);

	return (
		<>
			<IconButton
				tooltip={t("up")}
				icon={<ArrowUpwardIcon />}
				disabled={listInfo.noneSelected || listInfo.firstSelected}
				size={ButtonSize.LARGE}
				onClick={onMoveUp}
			/>
			<IconButton
				tooltip={t("down")}
				icon={<ArrowDownwardIcon />}
				disabled={listInfo.noneSelected || listInfo.lastSelected}
				size={ButtonSize.LARGE}
				onClick={onMoveDown}
			/>
			<IconButton
				tooltip={t("delete")}
				icon={<DeleteIcon />}
				disabled={listInfo.noneSelected}
				size={ButtonSize.LARGE}
				onClick={onDelete}
			/>
		</>
	);
}
